import React from 'react';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import { useParams } from 'react-router-dom';
import { Grid, Container } from '@material-ui/core';
import Title from 'components/Title';
import { useStyles } from './BillingDetails.styled';
import { ReceivableDetails, ReceivableItems, ReceivableActions } from 'components/Receivable';
import Comments from 'components/Comments';
import Logs from 'components/Logs';
import Images from 'components/Images';

const BillingDetails = () => {
  const classes = useStyles();
  const { id } = useParams();

  return (
    <Layout title={i18n.t('receivable.billing')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item>
                <Title title={i18n.t('receivable.billing_details', { id: id })} />
              </Grid>
              <ReceivableActions id={id} options={['preview', 'download']} />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <ReceivableDetails
                      id={id}
                      statusHide
                      receivableInfo={['from', 'to', 'source', 'completed_on', 'modified_on']}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Images
                      id={id}
                      title={i18n.t('common.images')}
                      sourceType="invoice"
                      noProfile
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <ReceivableItems id={id} resume={['quantity', 'total_invoiced']} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Comments type="invoice" id={+id} />
                  </Grid>
                  <Grid item xs={12}>
                    <Logs
                      targetId={parseInt(id)}
                      targetType="Invoice"
                      title={i18n.t('receivable.billing_logs')}
                      height={439}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default BillingDetails;
